import { format } from 'date-fns'
import { ReactNode, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button } from '../../components/button'
import { BackButton } from '../../components/button/backButton'
import { Status } from '../../components/cards/statusTag'
import Spinner from '../../components/spinner/Spinner'
import { PageHeader } from '../../components/typography/PageHeader'
import { SETTLEMENTSTATUS } from '../../constants'
import { formatCurrency } from '../../helpers'
import { useModalControl } from '../../hooks/useModalControl'
import Layout from '../../layout'
import { StatusTypes } from '../../types/types'
import { useGetSettlementsReportByIDQuery } from '../../redux-toolkits/reports/reports.slice'

export const SingleSettlementPage = () => {
  const { id } = useParams()

  const [details, setDetails] = useState<
    { title: string; value: ReactNode | string }[]
  >([])

  const { data, isFetching, isSuccess, refetch } =
    useGetSettlementsReportByIDQuery({
      settlementId: id ?? '',
    })

  const { handleModalOpen } = useModalControl()

  useEffect(() => {
    if ((data?.data, isSuccess)) {
      const item = data.data

      setDetails([
        {
          title: 'Transaction ID:',
          value: item._id,
        },
        {
          title: 'Order ID:',
          value: `#${item.order.orderNumber}`,
        },
        {
          title: 'Payment reference:',
          value: item?.paymentReference,
        },
        {
          title: 'Account number:',
          value: item.accountNumber,
        },
        {
          title: 'Bank name:',
          value: item.bankName,
        },
        {
          title: 'Account name:',
          value: item.accountName,
        },
        {
          title: 'Date:',
          value:
            item.settledDate || item.updatedAt
              ? `${format(
                  item.settledDate || item.updatedAt,
                  'dd/MM/yyyy h:mma',
                )}`
              : 'N/A',
        },
        {
          title: 'Transaction status:',
          value: (
            <Status
              text={item.status.toLowerCase()}
              type={
                (SETTLEMENTSTATUS.find(
                  (status) =>
                    status.name.toLowerCase() === item.status.toLowerCase(),
                )?.type ?? 'warn') as StatusTypes
              }
              key={`${item._id}-status`}
            />
          ),
        },
        {
          title: 'Order subtotal:',
          value: formatCurrency(item?.order?.amount >> 0),
        },
        {
          title: 'Product Name:',
          value: `${item.products.map((x) => x).join(',')}`,
        },
        {
          title: 'Creator Name:',
          value: `${item.vendorName}`,
        },
        {
          title: 'Amount settled:',
          value: formatCurrency(item?.amount ?? 0),
        },
      ])
    }
  }, [data])

  return (
    <Layout>
      <div className="flex flex-col gap-10">
        <BackButton />

        <div className="flex items-center justify-between gap-4">
          <PageHeader
            title="Settlement Transaction Details"
            className="!mb-0"
          />

          {data?.data.status === 'FAILED' && (
            <Button
              type="button"
              label="Retry payment"
              primary
              className="!w-full max-w-[190px]"
              onClick={() => {
                handleModalOpen('confirmRetryModal')
              }}
            />
          )}
        </div>

        {isFetching ? (
          <Spinner fullScreen={false} />
        ) : (
          <div className="flex flex-col w-full max-w-[800px]">
            {details.map((detail, idx) => {
              const key = `${detail.title}-${idx}`

              return (
                <div
                  className="
                  py-4
                  first:pt-0 last:pb-0
                  border-b last:border-b-0
                  flex gap-4
                  items-center justify-between
                "
                  key={key}
                >
                  <span className="text-sec-black">{detail.title}</span>
                  <span className="text-black font-medium">{detail.value}</span>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </Layout>
  )
}
